import script from "./incomeCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./incomeCategory.vue?vue&type=script&setup=true&lang=js"

import "./incomeCategory.vue?vue&type=style&index=0&id=7878bac8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7878bac8"]])

export default __exports__